import { Fragment } from 'preact';

export const commonVouchersData = {
  mainHeading: 'Voucher Terms & Conditions',
  offerHighlights: [
    'This offer is run by InstaCred at specific merchants.',
    'Only users who have received the SMS from InstaCred will be eligible for the offer.',
    'Offer is applicable only on completing the transaction at the specific merchant site within the stipulated time period.',
    'Eligible users will receive the voucher link within 7 working days of successful completion of the transaction using Cardless EMI.',
    'Vouchers are provided by our partner Xoxo deals and user has to collect the voucher code using the unique link shared over SMS.',
  ],
  howToUseHeading: 'HOW TO USE THE VOUCHER?',
  stepsToUse: [
    'Successfully complete the transaction using Cardless EMI within 24 hours of receiving the offer SMS.',
    'You will receive the voucher link via SMS within 7 working days after your transaction is successfully verified.',
    'Click on the voucher link sent to your registered mobile number via SMS',
    'Click on Collect voucher on voucher page',
    'Copy the voucher code and secured pin (where applicable)',
    'Redeem the voucher on the Merchant’s website',
  ],
  terms: [
    {
      list:
        'Cardless EMI Voucher offer is applicable to select customers who have received the communication regarding this offer',
    },
    {
      list:
        'Offer Applicable only on purchases made using Cardless EMI through the following Banks powered by InstaCred',
      sublist: [
        'ICICI Bank Cardless EMI',
        'Kotak Mahindra Bank Cardless EMI',
        'HDFC Bank Cardless / No Swipe EMI',
        'IDFC First Bank Cardless EMI (Easy Buy Card)',
        'Bank of Baroda Cardless EMI',
      ],
    },
    {
      list: 'Only Transaction done will qualify for benefits under this offer',
    },
    {
      list: 'To qualify,',
      sublist: [
        'Transactions must be done within 24 hours from the time during which the SMS was sent to the user',
        'Transaction must be done Online at the merchant mentioned in the SMS communication sent to the user',
      ],
    },
    {
      list:
        'Eligible Users transacting during the Offer Period will be eligible for Rs. 500 Gift Voucher of merchant of our choice',
    },
    {
      list:
        'Voucher can be collected only on the Xoxoday link shared via SMS to the user by InstaCred',
    },
    {
      list:
        'The Voucher link will be active for 30 days, post which the link will expire. User will not be eligible for a new voucher link after 30 days.',
    },
    {
      list:
        'InstaCred will not be responsible for non-delivery of SMS for reasons beyond its control',
    },
    {
      list:
        'InstaCred will not be responsible if the user has advertently or inadvertently deletes the link received from the user or voucher SMS',
    },
    {
      list:
        'Each qualifying user will be eligible for a Maximum of 1 Gift Voucher during a 30-day period',
    },
    {
      list:
        'Link to collect the Gift Voucher will be sent to the Mobile Number that was used to do a transaction within 7 working days from the date on which the user qualifies',
    },
    {
      list:
        'User will not be eligible for benefits under this offer if the original qualifying transaction has been canceled or has been fully refunded',
    },
    {
      list: (
        <Fragment>
          The Gift voucher is being offered by InstaCred (Flexmoney). For
          complaints or queries, please reach out to{' '}
          <a href='mailto: contact@flexmoney.in'> contact@flexmoney.in</a>
        </Fragment>
      ),
    },
    {
      list:
        'The Bank or lending partner through which transaction is being done is not responsible for any deficiency in service related to this offer',
    },
    {
      list: 'Participation in the offer is Voluntary',
    },
    {
      list:
        'These terms and conditions do not overwrite any other terms and conditions related to your transaction, your purchase at the merchant, InstaCred, Flexmoney, Lender or any other conditions',
    },
    {
      list:
        'This voucher is provided by Xoxoday, all their terms and conditions additionally apply.',
    },
  ],
};

export const noCostsOffersData = {
  mainHeading: false,
  offerHighlights: false,
  howToUseHeading: false,
  stepsToUse: false,
  termsInfo:
    'The following terms and conditions apply to no-cost equated monthly installment ("EMI") transactions made using Cardless EMI powered by InstaCred at participating merchants through Flexmoney’s Partner Lenders.',
  terms: [
    {
      list:
        'The No-Cost EMI facility is being offered to the customers who make a purchase transaction on participating merchants’ websites, mobile application/ mobile site thereof (collectively, "Participating Merchant") using Cardless EMI powered by InstaCred through its partner Lenders, providing an EMI facility to its pre-approved customers.',
    },
    {
      list:
        'I understand that under this offer, I will get an upfront discount equivalent to the EMI interest cost charged by the bank, making it effectively No Cost EMI',
    },
    {
      list:
        'Applicable taxes on Interest and any other charges will be levied by the Lender',
    },
    {
      list:
        'The No-Cost EMI facility is being offered by Flexmoney and/or Merchants and brands (as the case may be) and does not amount to EMI/interest waiver extended by the bank. No Cost EMI discount is made available on select products, as determined from time to time by such sellers',
    },
    {
      list:
        'The No-Cost EMI payment option can be availed using the Cardless EMI / Debit Card EMI powered by InstaCred (facility of Flexmoney’s Partner Lender providing an EMI facility to its preapproved users) on Participating Merchant.',
    },
    {
      list:
        'No Cost EMI is not available under this program if purchases are made using other payment methods',
    },
    {
      list:
        'The Lenders issuing the Cardless EMI / Debit Card EMI facility reserve the right to charge Processing Fees and/or Goods and Services Tax (GST) or other applicable taxes on the purchase transactions undertaken on EMI which will be over and above the product price. This processing fee will be informed to the customer at the time of the transaction',
    },
    {
      list:
        'No Cost EMI discount will be calculated only on the eligible items in the cart as the case may be.',
    },
    {
      list: 'The customers may avail the No Cost EMI facility, provided that:',
      sublist: [
        'the order is not canceled by the customer or the participating merchant;',
        'or the product is not returned/exchanged by the customer.',
      ],
    },
    {
      list:
        'I understand and confirm that I will need to pay applicable EMI and interest on the total value of the order at the time of payment to the bank in accordance with the terms applicable. The interest cost charged by the bank overtime is being given back to me upfront at the time of this purchase',
    },
    {
      list:
        "Any returns/cancellations will be as per the Merchant's return/cancellation policy. In case of any kind of return/refund in an EMI transaction, interest already billed in a particular transaction will not be refundable under any circumstances",
    },
    {
      list:
        'In the case of a refund on the original transaction, the No Cost EMI Discount received by the customer on the transaction will be recovered on a pro-rata basis and the amount post adjustment of this discount recovery will be passed back to the customer through Flexmoney’s Lending Partner',
    },
    {
      list:
        'The EMI facility is made available to the customers by and at the sole discretion of the Lender(s) issuing the credit facility to the customer. Flexmoney, InstaCred, Participating Merchant, and/or the brand will not be liable for any claims on account of availability or non-availability of EMI facility. Customers having the credit facility may be required to enter into separate agreements or arrangements (by whatever name called) with their Lender to avail / use the EMI facility.',
    },
    {
      list:
        'Flexmoney, InstaCred, Participating Merchant, Brand, or the Lender reserve the right to stop the No Cost EMI option at any time without prior notice and without any liability',
    },
    {
      list:
        'These Terms and Conditions only pertain to the No Cost EMI Discount provided to the customer and do not override any other terms, conditions, or agreement as may be applicable',
    },
  ],
  noCostInfo: [
    {
      title: 'HOW DO YOU GET IT',
      content: [
        <Fragment>
          Select <span className='bold-text'>Cardless EMI</span> at check out
        </Fragment>,
        <Fragment>
          Select your preferred{' '}
          <span className='bold-text'>Cardless EMI lender</span>
        </Fragment>,
        <Fragment>
          Select tenure with <span className='bold-text'>NO COST</span>
        </Fragment>,
      ],
    },
    {
      title: 'CONDITIONS IN CASE OF CANCELLATION',
      content: [
        "Any returns/cancellations will be as per the Merchant's return/cancellation policy.",
        'In case of any kind of return/refund in an EMI transaction, interest already billed in a particular transaction will not be refundable under any circumstances',
        'In the case of a refund on the original transaction, the No Cost EMI Discount received by the customer on the transaction will be recovered on a pro-rata basis and the amount post adjustment of this discount recovery will be passed back to the customer through InstaCred Lending Partner',
      ],
    },
  ],
};

export const zebrsData = {
  bannerData: {
    header: 'Now Avail NO COST EMI on Zebrs',
    subHeader: (
      <Fragment>
        {' '}
        Purchase your favourite mobiles and accessories using{' '}
        <span className='bold-text'>NO COST CARDLESS EMI</span>
      </Fragment>
    ),
    btnUrl: 'https://www.zebrs.com/',
  },
  whatYouGet: {
    title: 'WHAT YOU GET',
    content: [
      'No Cost EMI on eligible tenures across eligible lenders',
      'To make this a No Cost EMI offer, amount equivalent to the interest payable by you has been provided as an Upfront Instant Discount to you',
      'The total amount you pay to the bank will be equivalent to the price of your order',
      'Eligible tenures: 3, 6, 9, 12 months',
      <Fragment>
        Eligible lenders:{' '}
        <ul>
          <li>Kotak Mahindra Bank</li>
          <li>ICICI Bank</li>
          <li>HDFC Bank</li>
          <li>IDFC First Bank</li>
        </ul>
      </Fragment>,
    ],
  },
};

export const nilkamalData = {
  bannerData: {
    header: 'Now Avail NO COST EMI on Nilkamal',
    subHeader: (
      <Fragment>
        Purchase your favourite furniture and decor using{' '}
        <span className='bold-text'>NO COST CARDLESS EMI</span>
      </Fragment>
    ),
    btnUrl: 'https://www.nilkamalfurniture.com/',
    desktopBanner: 'https://iccdn.in/offers/offers-tc-banner-d2.png',
    mobileBanner: 'https://iccdn.in/offers/offers-tc-banner-m2.png',
  },
  whatYouGet: {
    title: 'WHAT YOU GET',
    content: [
      'No Cost EMI on eligible tenures across eligible lenders',
      'To make this a No Cost EMI offer, amount equivalent to the interest payable by you has been provided as an Upfront Instant Discount to you',
      'The total amount you pay to the bank will be equivalent to the price of your order',
      'Eligible tenure: 3 months',
      <Fragment>
        Eligible lenders:{' '}
        <ul>
          <li>Kotak Mahindra Bank</li>
          <li>ICICI Bank</li>
          <li>HDFC Bank</li>
        </ul>
      </Fragment>,
    ],
  },
};

export const mdComputersData = {
  bannerData: {
    header: 'Now Avail NO COST EMI on MD Computers',
    subHeader: (
      <Fragment>
        Purchase your favourite computers and accessories using{' '}
        <span className='bold-text'>NO COST CARDLESS EMI</span>
      </Fragment>
    ),
    btnUrl: 'https://mdcomputers.in/',
    desktopBanner: 'https://iccdn.in/offers/offers-tc-banner-d4.png',
    mobileBanner: 'https://iccdn.in/offers/offers-tc-banner-m4.png',
  },
  whatYouGet: {
    title: 'WHAT YOU GET',
    content: [
      'No Cost EMI on eligible tenures across eligible lenders',
      'To make this a No Cost EMI offer, amount equivalent to the interest payable by you has been provided as an Upfront Instant Discount to you',
      'The total amount you pay to the bank will be equivalent to the price of your order',
      'Eligible tenures: 3, 6, 9, 12 months',
      <Fragment>
        Eligible lenders:{' '}
        <ul>
          <li>Kotak Mahindra Bank</li>
          <li>ICICI Bank</li>
          <li>HDFC Bank</li>
          <li>IDFC First Bank</li>
        </ul>
      </Fragment>,
    ],
  },
};

export const lotMobilesData = {
  bannerData: {
    header: 'Now Avail NO COST EMI on Lot Mobiles',
    subHeader: (
      <Fragment>
        Purchase your favourite mobiles and accessories using{' '}
        <span className='bold-text'>NO COST CARDLESS EMI</span>
      </Fragment>
    ),
    btnUrl: 'https://www.lotmobiles.com/',
  },
  whatYouGet: {
    title: 'WHAT YOU GET',
    content: [
      'No Cost EMI on eligible tenures across eligible lenders',
      'To make this a No Cost EMI offer, amount equivalent to the interest payable by you has been provided as an Upfront Instant Discount to you',
      'The total amount you pay to the bank will be equivalent to the price of your order',
      'Eligible tenure: 3 months',
      <Fragment>
        Eligible lenders:{' '}
        <ul>
          <li>Kotak Mahindra Bank</li>
          <li>ICICI Bank</li>
          <li>HDFC Bank</li>
          <li>IDFC First Bank</li>
        </ul>
      </Fragment>,
    ],
  },
};
export const bigCData = {
  bannerData: {
    header: 'Now Avail NO COST EMI on BigC',
    subHeader: (
      <Fragment>
        Purchase your favourite mobiles and accessories using{' '}
        <span className='bold-text'>NO COST CARDLESS EMI</span>
      </Fragment>
    ),
    btnUrl: 'https://www.bigcmobiles.com/',
  },
  whatYouGet: {
    title: 'WHAT YOU GET',
    content: [
      'No Cost EMI on eligible tenures across eligible lenders',
      'To make this a No Cost EMI offer, amount equivalent to the interest payable by you has been provided as an Upfront Instant Discount to you',
      'The total amount you pay to the bank will be equivalent to the price of your order',
      'Eligible tenure: 3 months',
      <Fragment>
        Eligible lenders:{' '}
        <ul>
          <li>Kotak Mahindra Bank</li>
          <li>ICICI Bank</li>
          <li>HDFC Bank</li>
          <li>IDFC First Bank</li>
        </ul>
      </Fragment>,
    ],
  },
};
export const doctorDreamsData = {
  bannerData: {
    header: 'Now Avail NO COST EMI on Doctor Dreams',
    subHeader:
      'Available on 3, 6, 9, 12 months across all Cardless EMI Lenders*',
    btnUrl: 'https://doctordreams.com/',
  },
  whatYouGet: {
    title: 'WHAT YOU GET',
    content: [
      'No Cost EMI on eligible tenures across eligible lenders',
      'To make this a No Cost EMI offer, amount equivalent to the interest payable by you has been provided as an Upfront Instant Discount to you',
      'The total amount you pay to the bank will be equivalent to the price of your order',
      'Eligible tenure: 3 months',
      <Fragment>
        Eligible lenders:{' '}
        <ul>
          <li>ICICI Bank</li>
          <li>HDFC Bank</li>
          <li>Bank of Baroda</li>
        </ul>
      </Fragment>,
    ],
  },
};

export const sleepyheadData = {
  bannerData: {
    header: 'Now Avail NO COST EMI on Sleepyhead',
    subHeader: (
      <Fragment>
        Purchase your favourite Furniture and Home furnishing accessories using{' '}
        <span className='bold-text'>NO COST CARDLESS EMI</span>
      </Fragment>
    ),
    btnUrl: 'https://mysleepyhead.com/',
    desktopBanner: 'https://iccdn.in/offers/offers-tc-banner-d3.png',
    mobileBanner: 'https://iccdn.in/offers/offers-tc-banner-m3.png',
  },
  whatYouGet: {
    title: 'WHAT YOU GET',
    content: [
      'No Cost EMI on eligible tenures across eligible lenders',
      'To make this a No Cost EMI offer, amount equivalent to the interest payable by you has been provided as an Upfront Instant Discount to you',
      'The total amount you pay to the bank will be equivalent to the price of your order',
      'Eligible tenure: 3 months',
      <Fragment>
        Eligible lenders:{' '}
        <ul>
          <li>Kotak Mahindra Bank</li>
          <li>ICICI Bank</li>
          <li>HDFC Bank</li>
          <li>IDFC First Bank</li>
        </ul>
      </Fragment>,
    ],
  },
};

export const pepperfryData = {
  bannerData: {
    header: 'Now Avail NO COST EMI on Pepperfry',
    subHeader: (
      <Fragment>
        Purchase your favourite Furniture and Home furnishing accessories using{' '}
        <span className='bold-text'>NO COST CARDLESS EMI</span>
      </Fragment>
    ),
    btnUrl: 'https://www.pepperfry.com/',
    desktopBanner: 'https://iccdn.in/offers/offers-tc-banner-d2.png',
    mobileBanner: 'https://iccdn.in/offers/offers-tc-banner-m2.png',
  },
  whatYouGet: {
    title: 'WHAT YOU GET',
    content: [
      'No Cost EMI on eligible tenures across eligible lenders',
      'To make this a No Cost EMI offer, amount equivalent to the interest payable by you has been provided as an Upfront Instant Discount to you',
      'The total amount you pay to the bank will be equivalent to the price of your order',
      'Eligible tenure: 3 months',
      <Fragment>
        Eligible lenders:{' '}
        <ul>
          <li>Kotak Mahindra Bank</li>
          <li>ICICI Bank</li>
          <li>HDFC Bank</li>
        </ul>
      </Fragment>,
    ],
  },
};

export const sangeethaMobilesData = {
  bannerData: {
    header: 'Now Avail NO COST EMI on Sangeetha Mobiles',
    subHeader: (
      <Fragment>
        Purchase your favorite mobiles and accessories using{' '}
        <span className='bold-text'>NO COST CARDLESS EMI</span>
      </Fragment>
    ),
    btnUrl: 'https://www.sangeethamobiles.com?utm_campaign=instacred_bic',
    desktopBanner: 'https://iccdn.in/offers/offers-tc-banner-d5.jpg',
    mobileBanner: 'https://iccdn.in/offers/offers-tc-banner-m5.jpg',
  },
  whatYouGet: {
    title: 'WHAT YOU GET',
    content: [
      'No Cost EMI on eligible tenures across eligible lenders',
      'To make this a No Cost EMI offer, amount equivalent to the interest payable by you has been provided as an Upfront Instant Discount to you',
      'The total amount you pay to the bank will be equivalent to the price of your order',
      'Eligible tenure: 3, 6 months',
      <Fragment>
        Eligible lenders:{' '}
        <ul>
          <li>Kotak Mahindra Bank</li>
          <li>ICICI Bank</li>
          <li>HDFC Bank</li>
          <li>IDFC First Bank</li>
        </ul>
      </Fragment>,
    ],
  },
};



// WEBPACK FOOTER //
// ./constants/offersDetails.js